/* eslint-disable */
import React from "react";
import AccountTree from "../utils/AccountTree";
import { parseMoney } from "../utils";

const MappingSheets = ({ user_type, naics_code, sheet, values, tree, map_list, updateRows, getRelatedAccounts, accountsExpanded, rowsInExpand }) => {

  const updateFdr = (rowId, newValue, oldValue) => {
    updateRows([rowId], newValue, false, false, oldValue);
  };

  const MapList = ({ id, selected, map_list, updateFdr }) => (
    <select fdr-id={id} value={selected} className='map-sheet-selector' id='map-sheet-selector' data-hover='true' onChange={({ target }) => updateFdr(id, target.value, selected)} >
      {map_list.map((p, i) => (
        <optgroup label={p[0]} key={i}>
          {p[1].map((c, ii) => (
            <option key={ii}>
              {c}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  )

  const buildRow = ({ i, key, fullCopy, copy, padding, map, bold, header, header_is_total, total, padRow }) => {
    if (header && !header_is_total) return <tr key={i} id={i} ><td>{padding + copy}</td>{nTds()}</tr>;
    if (padRow) return <tr key={i + 100} id={i + 100} className="empty-row"><td>{'\u00A0'}</td>{nTds()}</tr>;

    const rows = [];

    rows.push(
      <tr key={i} id={i} className={map ? 'expandable-row' : ''} onClick={map ? () => getRelatedAccounts(fullCopy) : undefined}>
        {map ? <td className={bold ? 'bold' : ''}>{padding + copy} <div className='fa fa-caret-down'></div></td> : <td className={bold ? 'bold' : ''}>{padding + copy}</td>}
        {Object.keys(values).map((year, ii) => {
          let cashWarning6212 = false
          if (user_type === 'Admin' && naics_code.startsWith('6212') && key === 'cash') {
            cashWarning6212 = values[year][key] >= 500000
          }
          return (
            <td key={ii} style={cashWarning6212 ? { 'backgroundColor': '#feb9b9' } : {}} className={`mapping-balance-sheet-data ${bold ? 'bold' : ''}`}>{parseMoney(values[year][key])}</td>
          )
        })}
      </tr>
    );
    return rows;
  }

  const getCellStyle = (index, isFirstCell, totalRows) => {
    const baseStyle = {
      borderRight: '1px solid #538c36',
      backgroundColor: index % 2 === 0 ? '#baee9e' : '#d7ffc3',
    };

    if (isFirstCell) {
      baseStyle.borderLeft = '1px solid #538c36';
    }

    if (index === 0) {
      baseStyle.borderTop = '1px solid #538c36';
    } else if (index === totalRows - 1) {
      baseStyle.borderBottom = '1px solid #538c36';
    }

    if (totalRows === 1) {
      baseStyle.borderBottom = '1px solid #538c36';
    }

    return baseStyle;
  };

  const buildRowExpanded = (row, relatedRows) => {
    if (row.header && !row.header_is_total) return <tr key={row.i} id={row.i} ><td>{row.padding + row.copy}</td>{nTds()}</tr>;
    if (row.padRow) return <tr key={row.i + 100} id={row.i + 100} className="empty-row"><td>{'\u00A0'}</td>{nTds()}</tr>;

    const rows = [];
    let years = Object.keys(values)

    rows.push(
      <tr key={row.i} id={row.i} className='expandable-row' onClick={() => getRelatedAccounts(row.fullCopy)}>
        <td className='bold'>{row.padding + row.copy} <div className='fa fa-caret-down'></div></td>
        {years.map((year, ii) => {
          let cashWarning6212 = false
          if (user_type === 'Admin' && naics_code.startsWith('6212') && row.key === 'cash') {
            cashWarning6212 = values[year][row.key] >= 500000
          }
          return (
            <td key={ii} style={cashWarning6212 ? { 'backgroundColor': '#feb9b9' } : {}} className={`mapping-balance-sheet-data ${row.bold ? 'bold' : ''}`}>{parseMoney(values[year][row.key])}</td>
          )
        })}
      </tr>
    );


    if (relatedRows.length > 0) {
      relatedRows.forEach((r, index) => {
        const firstCellStyle = getCellStyle(index, true, relatedRows.length);
        const nextCellStyle = getCellStyle(index, false, relatedRows.length);

        rows.push(
          <tr key={`${r.id}-${row.i}`} id={`${r.id}-${row.i}`} >
            <td style={firstCellStyle}>
              <div className='account-and-map-list-container'>
                <span>{row.padding + r.extracted_account}</span>
                <MapList id={r.id} map_list={map_list} selected={r.final_account} updateFdr={updateFdr} />
              </div>
            </td>
            {
              years.map((year, ii) => {
                return (
                  <td key={`${r.id}-${ii}`} className={`mapping-balance-sheet-data`} style={nextCellStyle}>{parseMoney(r[`year_${year}`])}</td>
                )
              })
            }
          </tr >
        );
      })
    } else {
      rows.push(
        <tr key={`no-related-${row.i}`} id={`no-related-${row.i}`} >
          <td style={{ 'backgroundColor': '#b0e296' }}>
            No Rows Mapped to this Account.
          </td>
        </tr>
      );
    }

    return rows;
  }

  const buildRemainderRow = () => {
    return (
      <tr>
        <td className='bold'>Remainder (Out of Balance By):</td>
        {Object.keys(values).map((year, ii) => {
          const remainderVal = values[year]?.remainder ?? null;
          let colorVal = remainderVal && remainderVal > 0 ? 'red' : 'green'
          return (<td key={`${ii}-remainder`} className='mapping-balance-sheet-data' style={{ color: colorVal }}>
            {parseMoney(remainderVal)}
          </td>)
        })}
      </tr>
    )
  }

  const nTds = () => {
    const tds = [];
    for (let i = 0; i < Object.keys(values).length; i++) {
      tds.push(<td key={i}></td>);
    }
    return tds;
  }

  const buildRows = () => {
    const accountTree = new AccountTree({
      tree: tree[sheet],
      pad: true,
    });

    let accountsCopy = Object.keys(accountsExpanded)
    const rows = [];

    if (sheet === 'pnl' && naics_code && naics_code.startsWith('621')) {
      const healthCareRevenueChildKeys = [
        { key: 'total_revenue_gross_charges', copy: 'Gross Charges' },
        { key: 'total_revenue_adjustments', copy: 'Adjustments' }
      ]

      healthCareRevenueChildKeys.forEach((k, i) => {
        let hRow = {
          i: `${i}-${k.key}`,
          key: k.key,
          fullCopy: k.copy,
          copy: k.copy,
          padding: '',
          map: true,
          bold: true,
          header: false,
          header_is_total: false,
          total: null,
          padRow: false,
          parentKey: 'total_revenue',
          sheet: 'pnl',
          commonKey: 'revenue',
          alwaysDisplayRow: true,
        }

        if (hRow.map && accountsCopy.includes(hRow.fullCopy) && accountsExpanded[hRow.fullCopy]) {
          rows.push(buildRowExpanded(hRow, rowsInExpand[hRow.fullCopy]))
        } else {
          rows.push(buildRow(hRow))
        }
      })
      rows.push(buildRow({
        i: `4-revenue_empty_space_row`,
        key: 'space_before_revenue',
        copy: '',
        fullCopy: '',
        header: false,
        padding: '',
        sheet: 'pnl',
        emptyRow: true,
        padRow: true
      }))
    }

    accountTree.forEach((row) => {
      if (row.map && accountsCopy.includes(row.fullCopy) && accountsExpanded[row.fullCopy]) {
        rows.push(buildRowExpanded(row, rowsInExpand[row.fullCopy]))
      } else {
        rows.push(buildRow(row))
      }
    });
    return rows;
  }

  return (
    <table className="table table-striped table-bordered table-hover mapping-sheet">
      <thead className='mapper-sheet-header'>
        <tr>
          <th></th>
          {Object.keys(values).map((year, i) =>
            <th key={i} className="year-header">{year}</th>
          )}
        </tr>
      </thead>
      <tbody>
        {buildRows()}
        {buildRemainderRow()}
      </tbody>
    </table>
  )
}

export default MappingSheets;
